import React, { useEffect } from 'react';
import HeroStyle2 from '../../Hero/HeroStyle2';
import Section from '../../Section';
import AboutSectionStyle3 from '../../Section/AboutSection/AboutSectionStyle3';
import WorkingProcess from '../../Section/WorkingProcess';
import BannerSectionStyle2 from '../../Section/BannerSection/BannerSectionStyle2';
import AppointmentSectionStyle2 from '../../Section/AppointmentSection/AppointmentSectionStyle2';
import { pageTitle } from '../../../helpers/PageTitle';
import FunFactSection from '../../Section/FunFactSection';
import funfact from "../../Images/funfact.jpeg";
import about from "../../Images/about.png";
import a23 from "../../Images/a23.jpg";
import a2 from "../../Images/a2.png";
import pharmacybg from "../../Images/bg/pharmacybg.jpg"
import generalvideo from "../../Images/generalvideo.mp4"

const testimonialData = [
    {
        text: 'I recently had to bring my child to ProHealth for a minor injury, and I was so impressed with the care he received. The pediatrician was great with him and made him feel at ease, and the entire staff was kind and attentive.”',
        ratingNumber: '5',
        avatarImgUrl: '/images/home_1/avatar_2.png',
        avatarName: 'PAULO HUBERT',
        avatarDesignation: 'New York, USA',
    },
    {
        text: 'I recently had to bring my child to ProHealth for a minor injury, and I was so impressed with the care he received. The pediatrician was great with him and made him feel at ease, and the entire staff was kind and attentive.”',
        ratingNumber: '4.5',
        avatarImgUrl: '/images/home_1/avatar_2.png',
        avatarName: 'PAULO HUBERT',
        avatarDesignation: 'New York, USA',
    },
    {
        text: 'I recently had to bring my child to ProHealth for a minor injury, and I was so impressed with the care he received. The pediatrician was great with him and made him feel at ease, and the entire staff was kind and attentive.”',
        ratingNumber: '5',
        avatarImgUrl: '/images/home_1/avatar_2.png',
        avatarName: 'PAULO HUBERT',
        avatarDesignation: 'New York, USA',
    },
    {
        text: 'I recently had to bring my child to ProHealth for a minor injury, and I was so impressed with the care he received. The pediatrician was great with him and made him feel at ease, and the entire staff was kind and attentive.”',
        ratingNumber: '4.5',
        avatarImgUrl: '/images/home_1/avatar_2.png',
        avatarName: 'PAULO HUBERT',
        avatarDesignation: 'New York, USA',
    },
];
const workingProcessData = [
    {
        title: 'Recognizes Expired Items',
        subTitle:
            'The online pharmacy software system is a great way to manage pharmacy operations as it does not make bills for expired products. This software alerts the staff at the counter about the expired medicines and helps the store owner to systematically purchase new items.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_1.svg',
        number: '01',
    },
    {
        title: 'Systematic Sales',
        subTitle:
            'The expiry dates of products get displayed when the billing is done for different batches of the same product. The right batch of the item is chosen based on the FIFO (First In, First Out) and LIFO (Last In, First Out) policy.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_2.svg',
        number: '02',
    },
    {
        title: 'Patients Medical History',
        subTitle:
            'With the help of retail pharmacy software systems, store owners and pharmacists can monitor the patient’s treatment as per defined safety standards. Pharmacists can also identify purchase patterns and advise the patient well in advance to get the medication.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_3.svg',
        number: '03',
    },
    {
        title: 'Barcode Labels',
        subTitle:
            'A barcode label is applied to all products before they are distributed to pharmacies and stores. Automate labeling of medication and print expiry dates of medicines with the help of the latest pharmacy software for pharmacy store. Also, the software helps calculate the number of labels needed.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_4.svg',
        number: '04',
    },
    {
        title: 'Influence Customer Shopping Behaviour',
        subTitle:
            'Customer relationship management module of the pharmacy software stores all details about the customer. The pharmaceutical software helps owners send emails and SMS alerts to customers about lucrative offers and promotional schemes. This wins a customer’s trust and increases the owner’s customer base.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_5.svg',
        number: '05',
    },
    {
        title: 'Automatic Delivery',
        subTitle:
            'The pharma distribution software has an interesting feature of automatically assigning orders to various distribution channels depending on thesupply date of the items and the number of days needed to deliver the order to the customers.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_2.svg',
        number: '06',
    },
    {
        title: 'Maintain Separate Registers/Folders',
        subTitle:
            'The store owner or pharmacist can maintain a separate register that has details of all the drugs stored in the store with the help of the pharmacy folder. This is a great feature as it keeps track of the composition of medicines and provides substitutes of the medicine that is not available for sale. This is a life-saving alternative in case of emergencies.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_1.svg',
        number: '07',
    },
    {
        title: 'Pharmacy B2B Solution',
        subTitle:
            'Wholesale Houses or chain of Retail stores who has central purchase organization are in need of comprehensive platform to take of all business process, which takes over burden of tracking inventory movements, pricing, sales, purchases, returns, credit management, Credit memos, Debit Memos, Payments, accounting and reporting Inventory Management and tracking are one of the key features which not only helps on operation also get to know trail balance on day to day basis. Adopting Medna Data Systems will induce the best practices in industry and follow compliance of industry best practices l and finally reduce the cost and increase the visibility to operations process. We are proud to provide a system which is thought for next 10 ten years of maintaining records.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_1.svg',
        number: '08',
    },
    {
        title: 'Efficient Workflow Management',
        subTitle:
            'Streamlines The Process Of Indents From Store To Cpo, Reorder Levels And Pricing Changes.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_1.svg',
        number: '09',
    },
    {
        title: 'Connect People With Vendor And Customer For Better Transparency',
        subTitle:
            'with Interactive Whatsapp Messages, Purchase Request , Reorder Level And Payment Process Makes Information Transparent To Stores And Cpo.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_1.svg',
        number: '10',
    },
];
const blogData = [
    {
        title: 'The Benefits of Mindfulness Meditation for Stress and Anxiety',
        thumbUrl: 'images/home_1/post_1.jpeg',
        date: 'May 1, 2023',
    },
    {
        title: 'Healthy Eating on a Budget: Tips and Strategies',
        thumbUrl: 'images/home_1/post_2.jpeg',
        date: 'May 4, 2023',
    },
    {
        title: 'The Importance of Regular Cancer Screenings and Early Detection',
        thumbUrl: 'images/home_1/post_3.jpeg',
        date: 'May 1, 2023',
    },
];
const faqData = [
    {
        title: 'What services does ProHealth offer?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
    {
        title: 'How do I schedule an appointment with ProHealth?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
    {
        title: 'Do you accept insurance?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
    {
        title: 'What should I bring to my appointment?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
    {
        title: 'How do I request a prescription refill?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
];
const brandData = [
    {
        imgUrl: process.env.PUBLIC_URL + '/images/brand_1.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_2.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_3.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_4.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_5.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_6.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_7.png',
        imgAlt: 'Brand',
    },
];

const funFactData = [
    { number: '15+', title: 'Years of experience' },
    { number: '1.6 Cr', title: 'Patient Registration' },
    { number: '700000+', title: 'Transactions per day.' },
    { number: '300+', title: 'Hospitals,Diagnostic Centers and Pharmacies Customers' },
    { number: '5+', title: 'Countries Customers' },
];

export default function Pharmacy() {
    pageTitle('Home V2');
    
    // Preload the background image for faster loading
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = pharmacybg;
        link.fetchPriority = 'high';
        document.head.appendChild(link);
        
        // Also preload the image in browser cache
        const img = new Image();
        img.src = pharmacybg;
        
        return () => {
            if (document.head.contains(link)) {
                document.head.removeChild(link);
            }
        };
    }, []);
    
    return (
        <>
            <HeroStyle2
                title="Pharmacy Solutions"
                subTitle="Medna Data Systems Supply Chain provides comprehensive infrastructure in terms supply
         chain business which involves Procurement, Sales, Inventory Monitor, Credit Control,
          Accounting and Payments. Medna Data Systems is an integrated product that includes various modules for
           health care platform such as HMS, LIS, IP Management, Clinical Integration, 
           Inventory Management, Wholesale Business, Retail Stores, Asset Management, Patient B2C Portal
            much more."
                bgUrl={pharmacybg}
                imgUrl={process.env.PUBLIC_URL + "/images/home_2/patents.png"}
            // btnText="Doc Choice"
            // btnUrl="/"
            />
            <Section topMd={175} topLg={125} topXl={85}>
                <FunFactSection
                    bgUrl={funfact}
                    data={funFactData}
                />
            </Section>

            {/* <Section bottomMd={125} bottomLg={125} bottomXl={85}>
        <DepartmentSectionStyle4
          sectionTitle="For Your Health"
          sectionTitleUp="OUR DEPARTMENTS"
          data={departmentData}
        />
      </Section> */}
            {/* <Section
        className="cs_bg_filed"
        style={{ backgroundImage: `url(/images/home_2/testimonial_bg.svg)` }}
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <TestimonialSectionStyle2
          sectionTitle="What Are the Benefits of <br /> Electronic Health Records?"
          sectionTitleUp="BENEFITS"
          data={testimonialData}
        />
      </Section> */}
            <Section
                topMd={185}
                topLg={140}
                topXl={100}
                bottomMd={200}
                bottomLg={150}
                bottomXl={110}
            >
                <WorkingProcess
                    sectionTitle="Some Of The Key B2C Features For Pharmacist"
                    sectionTitleUp=""
                    sectionTitleDown=""
                    data={workingProcessData}
                />
            </Section>
            <Section>
                <BannerSectionStyle2
                    bgUrl={a23}
                    title="Don’t Let Your Hospital <br />Take a Backseat!"
                    subTitle="Schedule an demo with one of our experienced <br />professionals today!"
                />
            </Section>
            {/* <Section topMd={190} topLg={145} topXl={105}>
        <BlogSectionStyle3
          sectionTitle="Latest Update"
          sectionTitleUp="BLOG POSTS"
          sectionTitleDown=""
          sectionSubTitle=""
          data={blogData}
        />
      </Section> */}
            <Section bottomMd={190} bottomLg={145} bottomXl={105}>
                <AboutSectionStyle3
                    titleUp="Decades of expertise and market leadership. A distinguished history of 
          innovative Healthcare Solutions."
                    title="Meet The Minds Behind Medna Data Systems"
                    subTitle="Building compliant, scalable healthcare technology for the UAE.
Medna Data Systems is a healthcare technology company focused on delivering a robust, 
regulatory-ready Healthcare ERP and HMIS platform for clinics and hospitals operating in the UAE.
We bring together deep technical expertise, healthcare domain knowledge, and real-world implementation
 experience to solve one core problem: making healthcare operations simpler, compliant, and efficient
  without compromising patient data or clinical workflows."
                    imgUrl={about}
                />
            </Section>
            {/* Start FAQ Section */}
            {/* <Section
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <FaqSectionStyle2
          data={faqData}
          sectionTitle="Usually Asked"
          sectionTitleUp="What People"
        />
      </Section> */}
            {/* End FAQ Section */}
            <Section>
                <AppointmentSectionStyle2
                    bgUrl={process.env.PUBLIC_URL + "/images/home_2/appointment_bg.svg"}
                    imgUrl={a2}
                    sectionTitle="Appointment"
                    sectionTitleUp="BOOK AN"
                />
            </Section>
            {/* <Section
                topMd={200}
                topLg={150}
                topXl={110}
                bottomMd={200}
                bottomLg={150}
                bottomXl={110}
            >
                <BrandsSectionStyle2 data={brandData} />
            </Section> */}
        </>
    );
}
